import React, { useState , useEffect } from "react";
import moment from 'moment';

import { connect } from "react-redux";

// import Container from "components/Container/Container";
import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import Radio from "components/Radio/Radio";
import Select from "components/Select/Select";
import Checkbox from "components/Checkbox/Checkbox";
import DateInput from "components/DateInput/DateInput";
import FormElement from "components/FormElement/FormElement";
import axios from "axios";

import { toggleDropdowns } from "helpers/utils";

import { DOCUMENT_UPLOAD_URL } from  "helpers/ApiEndpointConstants";

import { loadFoldersAction, loadFolderContentsAction, showAlertAction, loadSitesAction, loadDeptAction, isFileUploadingAction } from "store/actions/Actions";

import styles from "./UploadDocumentsModal.module.scss";

/**
 *
 * @param {Function} setShowModal - toggles the modal
 */
const UploadDocumentsModal = props => {
    const [state, setState] = useState({
        existingFolder: true,
        parentFolderId: 0,
        parentFolder: "",
        newFolder: "",
        regulatory_act: "",
        siteId: "",
        site: "",
        departmentId : "",
        department : "",
        expiration_date: "",
        frequency: "0",
        lock_tasks: false,
        launch_date: "",
        due: "",
        permissionLevel : true,
        admins_only : false,
        requires_attest: true,
        disableSiteDepartmentSelection: false
    });
    const [parentFolderId, setParentFolderId] = useState(state.parentFolderId);
    const [parentFolder, setParentFolder] = useState(state.parentFolder);
    const [newFolder, setNewFolder] = useState(state.newFolder);
    const [siteId, setSiteId] = useState(state.siteId);
    const [site, setSite] = useState(state.site);
    const [departmentId, setDepartmentId] = useState(state.departmentId);
    const [department, setDepartment] = useState(state.department);
    const [stateErrors, setStateErrors] = useState({
        regulatory_act: "",
    });
    const [document, setDocument] = useState([]);

    // Load folder stucture
    const { loadFoldersAction, folders, sites, departments, loadSitesAction } = props;
    

    useEffect(() => {
        loadFoldersAction()
    }, [loadFoldersAction]);

    const parentFolderProp = props.parentFolder;
    // Put folder structure in local state
    useEffect(() =>{
        if (parentFolderProp && parentFolderProp.id){
            setParentFolderId(parentFolderProp.id);
           
            if (parentFolderProp.permission_department){
                state.permissionLevel = false;
                setSiteId(parentFolderProp.permission_site);
                props.loadDeptAction({site: parentFolderProp.permission_site}); 
                setDepartmentId(parentFolderProp.permission_department);
                state.disableSiteDepartmentSelection = true;
            }
        }
    }, [folders, parentFolderProp]);

    useEffect(() => {
        if (!document) return;
        document.length > 0 && setStateErrors({...stateErrors, document: ''});
    }, [document]);

    useEffect(() =>{

        if (folders){
            let selected = folders.filter(f =>
                f.id === parentFolderId
            )
        
            if (selected && selected.length === 1){
                setParentFolder(selected[0].folder_name);
            }
        }
    }, [parentFolderId, folders]);

    useEffect(() =>{
        if (!state.existingFolder){
            setParentFolderId(0);
            setParentFolder("");
        }else{
            setNewFolder('');
        }
    }, [state.existingFolder]);
    
    useEffect(() => {
         if (!state.permissionLevel){
             loadSitesAction();
         }
     }, [ state.permissionLevel, loadSitesAction]);

     useEffect(() =>{
        if (sites){
            let selected = sites.filter(f =>
                f.id === siteId
            )
        
            if (selected && selected.length === 1){
                setSite(selected[0].name)
            }
        }
    }, [siteId, sites]);

    useEffect(() =>{
        if (departments){
            let selected = departments.filter(f =>
                f.id === departmentId
            )
        
            if (selected && selected.length === 1){
                setDepartment(selected[0].name)
            }
        }
    }, [departmentId, departments]);

    useEffect(() => {
        state.due && setStateErrors({...stateErrors, due: ''});
    }, [state.due]);

    const handleChangeRadio = inputName => e => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value === "true" ? true : false,
        }));
        setDepartment("");
        setDepartmentId("");
        setSite("");
        setSiteId("");
        // setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value
        }));
        // setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const statusFolderDropdown = React.createRef();
    const siteDropdown = React.createRef();
    const departmentDropdown = React.createRef();
    const regTypeRef = React.createRef();

    const handleDrop = e => {
        e.preventDefault();
        if (e.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (e.dataTransfer.items[i].kind === "file") {
                    const file = e.dataTransfer.items[i].getAsFile();
                    const reader = new FileReader();
                    reader.onload = e => {
                        setDocument(document => [...document, {
                            name: file.name,
                            file: file
                        }]);
                    };
                    reader.readAsArrayBuffer(file);
                }
            }
        }
    };

    const handleDragOver = e => {
        e.preventDefault();
    };

    const handleBrowse = (state, setState) => e => {
        e.preventDefault();
        let reader = new FileReader();
        const { files } = e.target;

        if (files){
            for (let i = 0; i < files.length; i++) {
                let file = files[i];

                reader.onload = res => {
                    setDocument(document => [...document, {
                        name: file.name,
                        file: file
                    }]);
                };
                reader.readAsArrayBuffer(file);
            }
        }
    };

    const handleAdminsOnly = (e) => {

        e.persist();
        setState((s) => ({
            ...s,
            admins_only: !state.admins_only
        }));
    }

    const handleRequiresAttest = (e) => {

        e.persist();
        setState((s) => ({
            ...s,
            requires_attest: !state.requires_attest
        }));
    }

    const uploadDocuments = document => {
        if (!state.regulatory_act ||
            (document && document.length === 0) ||
            (departmentId !== "" && (!state.launch_date ||
            !state.due))) {
            // Check for validation errors
            setStateErrors({
                regulatory_act: !state.regulatory_act ? 'Regulatory Act is required' : '',
                document: document && document.length === 0 ? 'Please add one ore more documents' : '',
                launch_date: !state.launch_date ? 'Launch date is required' : '',
                due: !state.due ? 'Due date is required' : '',
            });
            return;
        }

        let formData = new FormData();

        formData.append("permission_organization", parseInt(props.UserOrgSiteReducer.selected.org));
        
        if (parentFolderId){
            formData.append("parent_folder", parentFolderId);
        }

        if (newFolder){
            formData.append("newFolder", newFolder);
        }

        if (props.userData){
            formData.append("userid", props.userData.id);
            formData.append("username", props.userData.name);
        }

        if (siteId){
            formData.append("permission_site", siteId);
        }

        if (departmentId){
            formData.append("permission_department", departmentId);
        }

        if (state.admins_only){
            formData.append("admins_only", state.admins_only);
        }

        if (state.requires_attest){
            formData.append("requires_attest", state.requires_attest);
        }

        if (state.expiration_date){
            formData.append("expiration_date", state.expiration_date);
        }

        if (state.regulatory_act){
            formData.append("regulatory_act", state.regulatory_act);
        }

        if (state.launch_date){
            formData.append("launch_date", state.launch_date);
        }

        if (state.frequency){
            formData.append("frequency", state.frequency);
        }

        if (state.lock_tasks){
            formData.append("lock_tasks", state.lock_tasks);
        }

        if (state.due){
            formData.append("due", state.due);
        }

        for (let i=0; i< document.length; i++){
            formData.append("files[]", document[i].file);
        }

        props.setShowModal(false);
        props.isFileUploadingAction(true)
        axios.post(DOCUMENT_UPLOAD_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if (response.data.status === 'error'){
                let filesCount = response.data.files.length;
                let errorMessage = "";
                for (let i=0; i<filesCount; i++) {
                    if (response && response.data && response.data.files && response.data.files[i]['error']){
                        errorMessage += response.data.files[i]['error'] + '\n';
                    }
                }

                props.showAlertAction({
                        message: errorMessage || "File upload failed!",
                        color: "danger"
                    });
            }
            props.loadFolderContentsAction({parent_folder: parentFolderId});
        }).finally(() => {
            props.isFileUploadingAction(false);                
        });        
    }

    const handleRegSelect = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: (e.target.attributes && e.target.attributes.value) ? e.target.attributes.value.value : '',
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '', type: '' }));
    };

    const handleChangeFreq = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value,
            due: e.target.value === 0 ? state.due : moment(state.launch_date, 'YYYY-MM-DD').add(e.target.value, 'month').format('YYYY-MM-DD'),
        }));
        // setStateErrors((s) => ({ ...s, [inputName]: '' }));
    }

    const handleChangeLaunch = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value,
            due: state.frequency === 0 ? state.due : e.target.value && moment(e.target.value, 'YYYY-MM-DD').add(state.frequency, 'month').format('YYYY-MM-DD'),
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    }

    const handleCheckbox = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.checked
        }));
    };

    const frequencyListLabels = {
        "0": "One Time",
        "1": "Monthly",
        "3": "Quarterly",
        "6": "Biannually",
        "12": "Annually"
    }

    return (
        <Modal setShowModal={props.setShowModal} className={styles.modal}>
            <div className={styles["modal-header"]}>
                <h2 className={styles.heading}>Upload Documents</h2>
            </div>
            <div className={styles["modal-body"]} onClick={toggleDropdowns([
                statusFolderDropdown,
                siteDropdown,
                departmentDropdown,
                regTypeRef,
            ])}>

                <div className={styles["existing-folder"]}>

                    <div className={styles.reg}>
                        <strong>REGULATORY ACT</strong>
                    </div>

                    <FormElement
                        // labelText="REGULATORY ACT"
                        htmlFor="regulatory_act"
                        errorMessage={stateErrors["regulatory_act"]}
                    >
                        <Select
                            placeholder="Select regulatory act"
                            value={state.regulatory_act}
                            onClick={handleRegSelect("regulatory_act")}
                            dropdownToggleRef={regTypeRef}
                        >
                            <li value="HIPAA">HIPAA</li>
                            <li value="OSHA">OSHA</li>
                        </Select>
                    </FormElement>

                </div>

                <br />

                <div className={styles["existing-folder"]}>
                <div className={styles.reg}>
                        <strong>Select Existing Folder</strong>
                    </div>
                    <FormElement>
                    <Select
                        disabled={!state.existingFolder}
                        placeholder="Select Existing Folder"
                        // dropdownToggleRef={stateDropdownRef}
                        value={parentFolder}
                        dropdownToggleRef={statusFolderDropdown}
                        onClick={(e) => {statusFolderDropdown.current.click(); setParentFolderId(e.target.value+"") }}
                    >
                        <div className={styles["parent-folder"]}>
                        {folders && folders.map(f => (
                                <li
                                    value={f.id}
                                    key={f.id}
                                    className={`${styles.folder} ${
                                        styles[`depth-${f.level}`]
                                    }`}
                                >
                                    <i
                                        className={
                                            f.level === "0"
                                                ? "fas fa-folder"
                                                : "far fa-folder"
                                        }
                                    />
                                    {f.folder_name} 
                                </li>
                            ))}
                            </div>
                    </Select>
                    </FormElement>
                </div>
                
                    <div className={styles["existing-folder"]}>

                        <div className={styles["permissions"]}>
                            <b>PERMISSION LEVEL</b>
                        </div>
                        
                        <div>
                            {!state.disableSiteDepartmentSelection &&
                                <Radio
                                    checked={state.permissionLevel}
                                    labelText="Entire Organization (default)"
                                    onChange={handleChangeRadio("permissionLevel")}
                                    value={true}
                                />
                            }
       
                            <div className={styles["permission-level"]}>
                                <Radio
                                    checked={!state.permissionLevel}
                                    labelText={false}
                                    onChange={ handleChangeRadio("permissionLevel") }
                                    value={(parentFolderProp && parentFolderProp.department) ? parentFolderProp.site : false}
                                />
                                <Select
                                    disabled={Boolean(state.permissionLevel)|| state.disableSiteDepartmentSelection}
                                    placeholder="Select Site"
                                    value={site}
                                    dropdownToggleRef={siteDropdown}
                                    onClick={ (e) => {
                                        siteDropdown.current.click();
                                        setSiteId(e.target.value+"");
                                        setDepartment("");
                                        setDepartmentId("");
                                        props.loadDeptAction({ site: e.target.value });
                                    }}
                                >
                                    {sites && sites.map(f => (
                                    <li
                                        value={f.id}
                                        key={f.id}>
                                    {f.name}</li>
                                ))}
                                </Select>
                            </div>
                            <div className={styles["permission-level"]}>    
                                <div className={styles["permission-department"]}></div>         
                                <Select
                                    disabled={!site || state.disableSiteDepartmentSelection}
                                    placeholder="Select Department"
                                    dropdownToggleRef={departmentDropdown}
                                    value={department}
                                    onClick={(e) => {departmentDropdown.current.click(); setDepartmentId(e.target.value+""); }}
                                >
                                {departments && departments.map(f => (
                                    <li
                                        value={f.id}
                                        key={f.id}>
                                    {f.name}</li>
                                ))}
                                </Select>
                            </div>
                        <div>
                        <div className={styles["permission-level"]}>  
                            <Checkbox onChange={handleAdminsOnly} checked={state.admins_only} labelText="Viewable by admins only" />
                        </div>
                        <div className={styles["permission-level"]}>  
                            <Checkbox onChange={handleRequiresAttest} checked={state.requires_attest} labelText="Requires Attestation" />
                        </div>
                        </div>
                        </div> 
                    </div>

                    <br />
                    <br />

                    {departmentId !== "" && <div className={styles["existing-folder"]}>
        
                        <div className={styles["training"]}>
                            <b>TRAINING SETTINGS</b>
                        </div>

                        <div className={styles.holder}>

                            <FormElement
                                labelText="FREQUENCY"
                                htmlFor="frequency"
                            >
                                <Select
                                    value={state.frequency}
                                    name="frequency"
                                    onClick={handleChangeFreq("frequency")}
                                    labels={frequencyListLabels}
                                >
                                    {Object.entries(frequencyListLabels).map((frequency) => <li key={frequency[0]} value={frequency[0]}>{frequency[1]}</li>)}
                                </Select>
                            </FormElement>

                            <FormElement
                                labelText="LAUNCH DATE"
                                htmlFor="launch_date"
                                className={styles.reminder}
                                errorMessage={stateErrors.launch_date}
                            >
                                <DateInput
                                    onChange={handleChangeLaunch("launch_date")}
                                    value={state.launch_date}
                                />
                            </FormElement>

                        </div>

                        <br />

                            <FormElement
                                labelText="DUE DATE"
                                htmlFor="due"
                                errorMessage={stateErrors.due}
                            >
                                <DateInput
                                    disabled={state.frequency !== "0" && state.frequency !== 0}
                                    // onChange={handleChange("due")}
                                    value={state.due}
                                />
                            </FormElement>


                        <br />

                        <div className={styles.holder}>
                            <Checkbox
                                labelText="Lock tasks"
                                disabled={state.frequency == 0 ? true : false}
                                checked={state.frequency == 0 ? false : state.lock_tasks}
                                onChange={handleCheckbox("lock_tasks")}
                                className={styles["complete"]}
                            />
                        </div>

                        <br />

                    </div>}


                    <div className={styles["expiration-date"]}>

                        <div className={styles["expiration-date-label"]}>
                            <b>EXPIRATION DATE</b>
                        </div>
                        
                        <div>
                            <DateInput
                                className={styles["date-input"]}
                                value={state["expiration_date"]}
                                onChange={handleChange("expiration_date")}
                                // maxDate={moment().format('YYYY-MM-DD')}
                            />
                        </div>
                    </div>

                <div
                    className={styles["drag-n-drop"]}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                >
                    <i
                        className={`fal fa-arrow-to-bottom ${
                            styles["drag-icon"]
                            }`}
                    />
                    <p className={styles["dnd-paragraph"]}>
                        Drag &amp; drop documents here
                    </p>
                    <span>
                        <hr className={styles.line} /> OR{" "}
                        <hr className={styles.line} />
                    </span>
                    <div className={styles.browse}>
                        <input
                            type="file"
                            accept=".doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            onChange={handleBrowse(document, setDocument)}
                        />
                        <Button
                            className={styles.button}
                            text="BROWSE FOR DOCUMENTS"
                        />
                    </div>
                    <div>
                        {document && document.map(d => (
                            <div key={d.name}>{d.name}</div>
                        ))}
                    </div>
                </div>
                {stateErrors.document && <span className={styles['validation-error']}>{stateErrors.document}</span>}
            </div>
            <div className={styles["modal-footer"]}>
                <Button
                    className={styles.button}
                    text="CANCEL"
                    onClick={() => props.setShowModal(false)}
                    color="secondary"
                />
                <Button
                    className={styles.button}
                    text="UPLOAD"
                    icon="fad fa-upload"
                    onClick={() => uploadDocuments(document)}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = state => ({
    folders: state.FoldersReducer.folders,
    parentFolder: state.FolderContentsReducer.parentFolder,
    userData: state.AuthReducer.userData,
    sites: state.SitesReducer.sites,
    departments: state.DepartmentsReducer.departments,
    UserOrgSiteReducer: state.UserOrgSiteReducer
});

const mapDispatchToProps = {
    loadFoldersAction,
    loadFolderContentsAction,
    showAlertAction,
    loadSitesAction,
    loadDeptAction,
    isFileUploadingAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadDocumentsModal);
